import Button from 'shared/ui/Button';
import React from 'react';
import { useDispatch } from 'react-redux';
import { newJob } from 'store/Jobs/actions';
import { Wrapper, Title, EmptyImage } from './styled';

const NoSelection = () => {
  const dispatch = useDispatch();
  return (
    <Wrapper>
      <EmptyImage />
      <Title>You don’t have any Jobs yet. </Title>
      <Button onClick={ () => dispatch(newJob()) }>Create a Job</Button>
    </Wrapper>
  );
};
export default NoSelection;
